// react
import { useMemo, useState } from 'react';
import { Filters } from 'react-table';

// third-party
import { Stack } from '@mui/material';

// project import
import MainCard from 'components/MainCard';
import ScrollX from 'components/ScrollX';
import BaseTable from 'components/base-table';
import { BaseTableFetchFuncProps } from 'components/base-table/dto';
import { mapFiltersToSpecification, mapSearchParamToSpecification } from 'utils/filtering/map-filter-to-specification';
import MessageHistoryTableColumnConfig, {
    DefaultMessageHistoryTableColumnIdToSortBy,
    DefaultMessageHistoryTableSortingType,
    DefaultVisibleMessageHistoryColumns,
    SearchableMessageHistoryTableColumnConfig,
} from './message-history-column-config';
import { useParams } from 'react-router';
import { MessageLogDto } from 'common/dto-types/message-dto';
import { fetchMessageHistoryList } from '../api';

const MessageHistoryPage = () => {
    const [messageLogsList, setMessageLogsList] = useState<Array<MessageLogDto>>([]);
    const [pageCount, setPageCount] = useState(0);
    const defaultVisibleColumnConfig = useMemo(() => DefaultVisibleMessageHistoryColumns, []);
    const defaultColumnConfig = useMemo(() => MessageHistoryTableColumnConfig, []);

    const { messageId } = useParams();

    const defaultHistoryFilters: Filters<any> = useMemo(() => {
        if (messageId === undefined) return [];
        else return [{ id: 'messageId', value: messageId }];
    }, [messageId]);

    const fetchData: BaseTableFetchFuncProps = async ({
        pageSize,
        pageIndex,
        sortingType,
        sortBy,
        filters,
        searchTerm,
    }) => {
        const data = await fetchMessageHistoryList({
            pageIndex,
            pageSize,
            sortingType,
            sortBy,
            andSpecifications: mapFiltersToSpecification(filters),
            orSpecifications:
                searchTerm && searchTerm.length > 0
                    ? mapSearchParamToSpecification(searchTerm, SearchableMessageHistoryTableColumnConfig)
                    : undefined,
        });

        if (data) {
            setMessageLogsList(data.elements);
            setPageCount(Math.ceil(data.total / pageSize));
        }
    };

    return (
        <MainCard content={false}>
            <Stack direction="column">
                <ScrollX>
                    <BaseTable
                        data={messageLogsList}
                        fetchData={fetchData}
                        pageCount={pageCount}
                        defaultColumnIdToSortBy={DefaultMessageHistoryTableColumnIdToSortBy}
                        defaultSortingType={DefaultMessageHistoryTableSortingType}
                        defaultColumnConfig={defaultColumnConfig}
                        defaultVisibleColumnConfig={defaultVisibleColumnConfig}
                        defaultFilters={defaultHistoryFilters}
                    />
                </ScrollX>
            </Stack>
        </MainCard>
    );
};

export default MessageHistoryPage;
